// // src/pages/Employee/CreateEmployee/steps/Step2PersonalFamily.tsx
// import React from 'react';
// import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody } from 'reactstrap';
// import { Plus, Trash2, Users } from 'react-feather';
// import { PersonalFamilyData, StepProps, emptyDependent } from '../../types/employee.types';

// const Step2PersonalFamily: React.FC<StepProps<PersonalFamilyData>> = ({ data, onChange, errors }) => {
//   const set = (field: keyof PersonalFamilyData, value: any) => {
//     onChange({ ...data, [field]: value });
//   };

//   const addDependent = () => {
//     onChange({ ...data, dependents: [...data.dependents, emptyDependent()] });
//   };

//   const removeDependent = (key: string) => {
//     onChange({ ...data, dependents: data.dependents.filter((d) => d._key !== key) });
//   };

//   const updateDependent = (key: string, field: string, value: string) => {
//     onChange({
//       ...data,
//       dependents: data.dependents.map((d) => (d._key === key ? { ...d, [field]: value } : d)),
//     });
//   };

//   return (
//     <div>
//       <h6 className="mb-3">Personal &amp; Family Details</h6>
//       <Row>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Marital Status</Label>
//             <Input
//               type="select"
//               value={data.marital_status}
//               onChange={(e) => set('marital_status', e.target.value)}
//             >
//               <option value="">Select...</option>
//               <option value="single">Single</option>
//               <option value="married">Married</option>
//               <option value="widowed">Widowed</option>
//               <option value="divorced">Divorced</option>
//             </Input>
//           </FormGroup>
//         </Col>
//         {data.marital_status === 'married' && (
//           <Col md={4}>
//             <FormGroup>
//               <Label className="fw-bold text-muted small text-uppercase">Spouse Name</Label>
//               <Input value={data.spouse_name} onChange={(e) => set('spouse_name', e.target.value)} />
//             </FormGroup>
//           </Col>
//         )}
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Age</Label>
//             <Input
//               type="number"
//               min={18}
//               value={data.age}
//               invalid={!!errors.age}
//               onChange={(e) => set('age', e.target.value)}
//             />
//           </FormGroup>
//         </Col>
//       </Row>

//       <div className="border-top pt-3 mt-2">
//         <div className="d-flex justify-content-between align-items-center mb-3">
//           <h6 className="mb-0 d-flex align-items-center gap-2">
//             <Users size={16} />
//             Dependents
//           </h6>
//           <Button color="primary" size="sm" onClick={addDependent} type="button">
//             <Plus size={14} className="me-1" />
//             Add Dependent
//           </Button>
//         </div>

//         {data.dependents.length === 0 && (
//           <div className="text-muted small fst-italic">No dependents added. This section is optional.</div>
//         )}

//         {data.dependents.map((dep, idx) => (
//           <Card key={dep._key} className="mb-3 border">
//             <CardBody className="py-3">
//               <div className="d-flex justify-content-between align-items-center mb-2">
//                 <span className="fw-semibold small text-muted">Dependent #{idx + 1}</span>
//                 <Button
//                   color="link"
//                   size="sm"
//                   className="p-0 text-danger"
//                   onClick={() => removeDependent(dep._key)}
//                   type="button"
//                 >
//                   <Trash2 size={14} className="me-1" />
//                   Remove
//                 </Button>
//               </div>
//               <Row>
//                 <Col md={4}>
//                   <FormGroup className="mb-2">
//                     <Label className="small text-muted">Name</Label>
//                     <Input
//                     //   size="sm"
//                       value={dep.name}
//                       onChange={(e) => updateDependent(dep._key, 'name', e.target.value)}
//                     />
//                   </FormGroup>
//                 </Col>
//                 <Col md={2}>
//                   <FormGroup className="mb-2">
//                     <Label className="small text-muted">Age</Label>
//                     <Input
//                     //   size="sm"
//                       type="number"
//                       value={dep.age}
//                       onChange={(e) => updateDependent(dep._key, 'age', e.target.value)}
//                     />
//                   </FormGroup>
//                 </Col>
//                 <Col md={3}>
//                   <FormGroup className="mb-2">
//                     <Label className="small text-muted">Relationship</Label>
//                     <Input
//                     //   size="sm"
//                       value={dep.relationship}
//                       onChange={(e) => updateDependent(dep._key, 'relationship', e.target.value)}
//                       placeholder="e.g. Son, Daughter"
//                     />
//                   </FormGroup>
//                 </Col>
//                 <Col md={3}>
//                   <FormGroup className="mb-2">
//                     <Label className="small text-muted">Education</Label>
//                     <Input
//                     //   size="sm"
//                       value={dep.education}
//                       onChange={(e) => updateDependent(dep._key, 'education', e.target.value)}
//                     />
//                   </FormGroup>
//                 </Col>
//                 <Col md={12}>
//                   <FormGroup className="mb-0">
//                     <Label className="small text-muted">Working Details</Label>
//                     <Input
//                     //   size="sm"
//                       value={dep.working_details}
//                       onChange={(e) => updateDependent(dep._key, 'working_details', e.target.value)}
//                       placeholder="Occupation / employer, if working"
//                     />
//                   </FormGroup>
//                 </Col>
//               </Row>
//             </CardBody>
//           </Card>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Step2PersonalFamily;

// src/pages/Employee/CreateEmployee/steps/Step2PersonalFamily.tsx

import React, { useMemo } from 'react';
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody, FormFeedback } from 'reactstrap';
import { Plus, Trash2, Users, Calendar, User, Briefcase } from 'react-feather';
import { PersonalFamilyData, StepProps, emptyDependent } from '../../types/employee.types';

const Step2PersonalFamily: React.FC<StepProps<PersonalFamilyData>> = ({ 
  data, 
  onChange, 
  errors,
  formData // Pass the entire form to access basicInfo
}) => {
  const set = (field: keyof PersonalFamilyData, value: any) => {
    onChange({ ...data, [field]: value });
  };

  // Auto-calculate age from DOB in Step 1
  const calculatedAge = useMemo(() => {
    if (!formData?.basicInfo?.date_of_birth) return '';
    
    const dob = new Date(formData.basicInfo.date_of_birth);
    if (isNaN(dob.getTime())) return '';
    
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    return age.toString();
  }, [formData?.basicInfo?.date_of_birth]);

  // Auto-populate age if not manually set
  const getAgeValue = () => {
    if (data.age && data.age !== '') return data.age;
    if (calculatedAge) return calculatedAge;
    return '';
  };

  const addDependent = () => {
    onChange({ 
      ...data, 
      dependents: [...data.dependents, emptyDependent()] 
    });
  };

  const removeDependent = (key: string) => {
    onChange({ 
      ...data, 
      dependents: data.dependents.filter((d) => d._key !== key) 
    });
  };

  const updateDependent = (key: string, field: string, value: string) => {
    onChange({
      ...data,
      dependents: data.dependents.map((d) => 
        (d._key === key ? { ...d, [field]: value } : d)
      ),
    });
  };

  // Auto-calculate dependent age from their DOB if available
  const calculateDependentAge = (dob: string) => {
    if (!dob) return '';
    const birthDate = new Date(dob);
    if (isNaN(birthDate.getTime())) return '';
    
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age.toString();
  };

  const updateDependentWithAge = (key: string, field: string, value: string) => {
    // If DOB is updated, auto-calculate age
    if (field === 'date_of_birth') {
      const age = calculateDependentAge(value);
      onChange({
        ...data,
        dependents: data.dependents.map((d) => 
          (d._key === key ? { ...d, [field]: value, age: age } : d)
        ),
      });
    } else {
      updateDependent(key, field, value);
    }
  };

  // Family member relationship options
  const relationshipOptions = [
    'Son',
    'Daughter',
    'Spouse',
    'Father',
    'Mother',
    'Brother',
    'Sister',
    'Grandfather',
    'Grandmother',
    'Uncle',
    'Aunt',
    'Nephew',
    'Niece',
    'Cousin',
    'Other'
  ];

  return (
    <div>
      <h6 className="mb-3">Personal &amp; Family Details</h6>
      
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">
              <User size={14} className="me-1" />
              Marital Status
            </Label>
            <Input
              type="select"
              value={data.marital_status}
              onChange={(e) => set('marital_status', e.target.value)}
            >
              <option value="">Select...</option>
              <option value="single">Single</option>
              <option value="married">Married</option>
              <option value="widowed">Widowed</option>
              <option value="divorced">Divorced</option>
              <option value="separated">Separated</option>
            </Input>
          </FormGroup>
        </Col>
        
        {data.marital_status === 'married' && (
          <Col md={4}>
            <FormGroup>
              <Label className="fw-bold text-muted small text-uppercase">
                <User size={14} className="me-1" />
                Spouse Name
              </Label>
              <Input 
                value={data.spouse_name} 
                onChange={(e) => set('spouse_name', e.target.value)} 
                placeholder="Enter spouse's full name"
              />
            </FormGroup>
          </Col>
        )}
        
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">
              <Calendar size={14} className="me-1" />
              Age
            </Label>
            <Input
              type="number"
              min={18}
              max={120}
              value={getAgeValue()}
              invalid={!!errors.age}
              onChange={(e) => set('age', e.target.value)}
              placeholder={calculatedAge ? `Auto-calculated: ${calculatedAge}` : 'Age'}
            />
            {calculatedAge && !data.age && (
              <div className="text-muted small mt-1">
                <span className="text-success">✓ Auto-calculated from Date of Birth</span>
              </div>
            )}
            {calculatedAge && data.age && data.age !== calculatedAge && (
              <div className="text-muted small mt-1">
                <span className="text-warning">⚠ Manual age differs from DOB ({calculatedAge})</span>
              </div>
            )}
            <FormFeedback>{errors.age}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>

      {/* Dependents Section */}
      <div className="border-top pt-3 mt-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0 d-flex align-items-center gap-2">
            <Users size={16} />
            Family Members / Dependents
            <span className="badge bg-light text-dark ms-2">
              {data.dependents.length}
            </span>
          </h6>
          <Button color="primary" size="sm" onClick={addDependent} type="button">
            <Plus size={14} className="me-1" />
            Add Family Member
          </Button>
        </div>

        {data.dependents.length === 0 && (
          <div className="text-center py-4 bg-light rounded-3 border border-dashed">
            <Users size={32} className="text-muted mb-2" />
            <div className="text-muted small">
              No family members added. Click <strong>"Add Family Member"</strong> to add.
            </div>
          </div>
        )}

        {data.dependents.map((dep, idx) => (
          <Card key={dep._key} className="mb-3 border shadow-sm">
            <CardBody className="py-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center gap-2">
                  <span className="badge bg-primary">
                    #{idx + 1}
                  </span>
                  <span className="fw-semibold small text-muted">
                    {dep.name || 'Unnamed Member'}
                  </span>
                </div>
                <Button
                  color="link"
                  size="sm"
                  className="p-0 text-danger"
                  onClick={() => removeDependent(dep._key)}
                  type="button"
                >
                  <Trash2 size={14} className="me-1" />
                  Remove
                </Button>
              </div>
              
              <Row>
                <Col md={4}>
                  <FormGroup className="mb-2">
                    <Label className="small text-muted fw-bold">
                      Full Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      bsSize="sm"
                      value={dep.name}
                      onChange={(e) => updateDependent(dep._key, 'name', e.target.value)}
                      placeholder="Enter full name"
                    />
                  </FormGroup>
                </Col>
                
                <Col md={2}>
                  <FormGroup className="mb-2">
                    <Label className="small text-muted fw-bold">Age</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      value={dep.age}
                      onChange={(e) => updateDependent(dep._key, 'age', e.target.value)}
                      placeholder="Auto"
  
                    />
                    
                  </FormGroup>
                </Col>
                
                <Col md={3}>
                  <FormGroup className="mb-2">
                    <Label className="small text-muted fw-bold">
                      <User size={12} className="me-1" />
                      Relationship <span className="text-danger">*</span>
                    </Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={dep.relationship}
                      onChange={(e) => updateDependent(dep._key, 'relationship', e.target.value)}
                    >
                      <option value="">Select...</option>
                      {relationshipOptions.map((rel) => (
                        <option key={rel} value={rel.toLowerCase()}>
                          {rel}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              
              <Row>
                <Col md={6}>
                  <FormGroup className="mb-2">
                    <Label className="small text-muted fw-bold">
                      <Briefcase size={12} className="me-1" />
                      Education / Qualification
                    </Label>
                    <Input
                      bsSize="sm"
                      value={dep.education}
                      onChange={(e) => updateDependent(dep._key, 'education', e.target.value)}
                      placeholder="e.g. B.Com, 12th Pass, ITI"
                    />
                  </FormGroup>
                </Col>
                
                <Col md={6}>
                  <FormGroup className="mb-0">
                    <Label className="small text-muted fw-bold">
                      <Briefcase size={12} className="me-1" />
                      Working Details
                    </Label>
                    <Input
                      bsSize="sm"
                      value={dep.working_details}
                      onChange={(e) => updateDependent(dep._key, 'working_details', e.target.value)}
                      placeholder="Occupation / Employer (if working)"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Step2PersonalFamily;